module.exports = __webpack_public_path__ + "assets/5-connect-denver-sales-recruiter.5bd15033.png";